import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a2d16d50"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-wrapper" }
const _hoisted_2 = { class: "modal-container" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Order Status History", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/Pjxzdmcgdmlld0JveD0iMCAwIDMyIDMyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDpub25lO3N0cm9rZTojMDAwO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2Utd2lkdGg6MnB4O308L3N0eWxlPjwvZGVmcz48dGl0bGUvPjxnIGlkPSJjcm9zcyI+PGxpbmUgY2xhc3M9ImNscy0xIiB4MT0iNyIgeDI9IjI1IiB5MT0iNyIgeTI9IjI1Ii8+PGxpbmUgY2xhc3M9ImNscy0xIiB4MT0iNyIgeDI9IjI1IiB5MT0iMjUiIHkyPSI3Ii8+PC9nPjwvc3ZnPg==" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { class: "history-table" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { class: "history-table-header" }, [
  /*#__PURE__*/_createElementVNode("th", null, "Date"),
  /*#__PURE__*/_createElementVNode("th", null, "User"),
  /*#__PURE__*/_createElementVNode("th", null, "Status Changed")
], -1))
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, { name: "modal" }, {
    default: _withCtx(() => [
      (_ctx.show)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "modal-mask",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.oBackDropClick && _ctx.oBackDropClick(...args)))
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _hoisted_4,
                  _createElementVNode("div", {
                    class: "close-button",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close()))
                  }, _hoisted_6)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("table", _hoisted_8, [
                    _hoisted_9,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: item.Id
                      }, [
                        _createElementVNode("td", null, _toDisplayString(item.StatusChangeDate), 1),
                        _createElementVNode("td", null, _toDisplayString(item.UserName), 1),
                        _createElementVNode("td", null, [
                          (item.Name)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(item.Name), 1))
                            : _createCommentVNode("", true),
                          (!item.Name)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(item.OldStatus) + " -> " + _toDisplayString(item.NewStatus), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128))
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _renderSlot(_ctx.$slots, "footer", {}, () => [
                    _createElementVNode("div", null, [
                      _createElementVNode("button", {
                        class: "btn btn-primary",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.close()))
                      }, "Close")
                    ])
                  ], true)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}